import AMP from './amp';

import { InjectableIdentity, IdentityType } from '../identity';

export interface OptionsType {
  apiOrigin: string;
  Identity: IdentityType | InjectableIdentity;
  baseDomain?: string;
}

export const options = (options: OptionsType) => {
  AMP.apiOrigin = options.apiOrigin;
  AMP._baseDomain = options.baseDomain;
  AMP._Identity = options.Identity;
};

export default options;
